// extracted by mini-css-extract-plugin
export default {"button_wrapper":"response-details-modal_button_wrapper__+tBq3","submit_button":"response-details-modal_submit_button__YY-eK"};